export default (store, {col, value}) => {
    if (!col.filterable) {
        return;
    }
    if (!_.isUndefined(value) || !_.isUndefined(store.state.filters[col.key])) {
        store.commit('setFilter', {key: col.key, value});
        store.dispatch('saveState');
        store.dispatch('getData');
    }
}



// WEBPACK FOOTER //
// ./src/app/store/base/actions/filter-col.js